import { createFileRoute } from "@tanstack/react-router";
import { useState } from "react";
import { useMutation } from "@tanstack/react-query";
import { apiClient } from "~/lib/orpc-client";
import { Button } from "~/components/ui/button";
import PersonalisationForm from "~/components/account/PersonalisationForm";
import DeleteAccountModal from "~/components/account/DeleteAccountModal";

export const Route = createFileRoute("/$tenantSlug/_protected/account")({
  component: TenantAccountPage,
});

function TenantAccountPage() {
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const { mutate, isPending } = useMutation({
    mutationFn: () => apiClient.users.createPasswordChangeTicket(),
    onSuccess: (data) => {
      if (data.ticket) {
        window.location.href = data.ticket;
      }
    },
  });

  return (
    <div className="bg-gray-50 min-h-screen">
      <div className="max-w-7xl mx-auto p-4 sm:p-6 pb-24">
        <div className="mb-6">
          <h1 className="text-2xl font-bold text-foreground">Account</h1>
          <p className="text-sm text-foreground mt-1">
            Manage your profile details and security settings.
          </p>
        </div>
        <div className="space-y-4 max-w-xl">
          <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-6">
            <PersonalisationForm />
          </div>

          <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-6">
            <h2 className="text-lg font-semibold text-gray-900">Security</h2>
            <p className="mt-2 text-sm text-gray-600">
              You can change your password here.
            </p>
            <Button
              onClick={() => mutate()}
              disabled={isPending}
              className="mt-4 w-full"
              variant="default"
              size="sm"
            >
              Change password
            </Button>
          </div>

          <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-6">
            <h2 className="text-lg font-semibold">Delete Account</h2>
            <p className="mt-2 text-sm text-gray-600">
              Permanently delete your account and all associated data. This
              action cannot be undone.
            </p>
            <Button
              onClick={() => setShowDeleteModal(true)}
              className="mt-4 w-full"
              variant="destructive"
              size="sm"
            >
              Delete Account
            </Button>
          </div>
        </div>
      </div>

      <DeleteAccountModal
        open={showDeleteModal}
        onOpenChange={setShowDeleteModal}
      />
    </div>
  );
}
